import { faker } from '@faker-js/faker'

import { ServiceOfferListItem } from '../../contracts/performance-ad/PartnerServiceOfferList'
import { Currency, TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getServiceOfferListItem = asBuilder((): ServiceOfferListItem => {
  const originalAmount = faker.number.int({ min: 1000, max: 100000 })
  const discountPercentage = faker.number.int({ min: 0, max: 100 })
  const discountedAmount = Math.round(originalAmount * ((100 - discountPercentage) / 100))

  return {
    id: faker.number.int(),
    isAvailable: faker.datatype.boolean(),
    hospitalId: faker.number.int({ min: 1, max: 1000 }),
    name: faker.commerce.productName(),
    squareImage: faker.image.url(),
    rectangleImage: faker.image.url(),
    description: faker.commerce.productDescription(),
    period: {
      startsAtUtc: faker.date.future().toISOString().slice(0, -1),
      endsAtUtc: faker.date.future().toISOString().slice(0, -1),
    },
    price: {
      currency: faker.helpers.enumValue(Currency),
      originalAmount,
      discountedAmount,
      discountPercentage,
      includeVat: faker.datatype.boolean(),
    },
    rating: {
      ratingCount: faker.number.int({ min: 0, max: 1000 }),
      totalRating: faker.number.float({ min: 0, max: 5 }),
    },
    badgeList: Array.from({ length: faker.number.int({ min: 0, max: 5 }) }).map(() =>
      faker.commerce.productAdjective(),
    ),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
  }
})
